@if (isChatWidgetMode()) {
  <!-- Standalone Chat Widget Mode - No layout, just the widget container -->
  <div class="chat-widget-container"></div>
} @else if (isAuthenticated()) {
  <wu-authenticated-layout>
    <router-outlet />
  </wu-authenticated-layout>
  <wu-health-system-modal />
  <wu-render-affirm-reg />
} @else {
  <router-outlet />
}
